// extracted by mini-css-extract-plugin
export default {"wrapper":"imageLabel_wrapper__pu3+b","imageLabel":"imageLabel_imageLabel__KIaQv"};